import Icon from '@/components/ui/AppIcon';

interface Benefit {
  id: string
  icon: string
  title: string
  description: string
}

const WhyChooseUsSection = () => {
  const benefits: Benefit[] = [
    {
      id: 'benefit_custom',
      icon: 'PencilSquareIcon',
      title: 'Custom Designs',
      description: 'Every container is tailored to your specific business needs and brand identity.',
    },
    {
      id: 'benefit_turnkey',
      icon: 'KeyIcon',
      title: 'Turn-Key Delivery',
      description: 'Fully equipped and ready to operate from day one. No additional setup required.',
    },
    {
      id: 'benefit_fast',
      icon: 'BoltIcon',
      title: 'Fast Production',
      description: 'Industry-leading 4-6 week production time gets you to market faster.',
    },
    {
      id: 'benefit_nationwide',
      icon: 'GlobeAmericasIcon',
      title: 'Nationwide Delivery',
      description: 'We deliver to all 50 states with professional logistics and setup support.',
    },
    {
      id: 'benefit_equipment',
      icon: 'WrenchScrewdriverIcon',
      title: 'Business-Ready Equipment',
      description: 'Professional-grade equipment and fixtures included for your industry.',
    },
  ]

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="reveal text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6">
            Why Choose <span className="text-primary">Us</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            We combine expertise, quality, and speed to deliver container solutions that exceed expectations.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.id}
              className="reveal container-card p-8 text-center"
              style={{ animationDelay: `${0.1 * (index + 1)}s` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <Icon name={benefit.icon as any} size={32} className="text-primary" />
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold font-montserrat text-foreground mb-3">
                {benefit.title}
              </h3>

              {/* Description */}
              <p className="text-muted-foreground leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUsSection